var _customer_id = is_empty(__st.cid) ? "" : __st.cid;
var _cart_token = null;
var _cart_item_count = null;
var _k2k_subcart_id = "SUBCART_K2K_01";
var _k2k_domain = "k2k.cconmausa.com";
var _k2k_home_url = "https://" + _k2k_domain;
var ___debug_log = "";


var _is_adding_to_cart = false;




$(document).ready(function () {

    //_console_log("cart.item_count : ");

    $(".cl_btn_add_to_cart").click(function (event) {
        event.preventDefault();
        on_click_add_to_cart_in_collection_page(this);
    });

    //alert("_customer_id:|" + _customer_id + "|||slide||");

    init_extcart();

});

function init_extcart() {
    if (typeof _customer_id == 'undefined')
    {
        _console_log("[WARNING] _customer_id undefined.");
        return;
    }

    _cart_token = getCookie("cart");

    if(!is_empty(_cart_token) &&  _cart_token.indexOf("?key=") > -1)
    {
        _cart_token = _cart_token.split("?key=")[0];
    }
    //_console_log("_cart_token : |" + _cart_token + "|");

    if (_cart_token == null || _cart_token == "")
    {
        //show_empty_cart();
        _console_log("[ERROR] cart cookie empty.");
        _cart_token = null;

        truncate_cart_ajax(callback_of_truncate_cart_for_init_token, null);

        return;
    }

    if (_customer_id != "")
    {
        _console_log("_customer_id : |" + _customer_id + "|");
//___add_to_debug_log("[init_extcart()] _customer_id:|" + _customer_id + "|");
//___add_to_debug_log("[cookie] |" + document.cookie + "|");
        merge_extcart_ajax(complete_merge_extcart);
    }
    else
    {
        //alert(window.location.pathname);
        if (window.location.pathname == "/cart")
        {
            if(window.CUSCart === undefined)
                get_extcart_ajax(show_extcart);
            else
                get_extcart_ajax(window.CUSCart.show_extcart);
        }
        else
        {
            get_extcart_ajax(show_header_cart_count);
        }
    }
//_console_log("___debug_log : |" + ___debug_log + "|");
//___send_debug_log_ajax(null, null);

    $(".subcart_item_chk").click(function () {
        //_console_log("variant_id to be removed : |" + $(this).attr("variant_id") + "|");
        if (_extcart_info != null)
        {
            //_extcart_info.
        }
    });
}



var merge_extcart_ajax = function (callback) {
    $.ajax
    ({
        type    : "GET",
        url     : _ext9api_url + "?action=merge_extcart&cart_token=" + _cart_token + "&customer_id=" + _customer_id,
        cache   : false,
        dataType: "json",
        async   : true,
        success : function (jsonData) {
            if (jsonData.result_code != null)
            {
                callback(jsonData);
            }
        },
        error   : function (XMLHttpRequest, textStatus, errorThrown) {
            _console_log("Error code : " + XMLHttpRequest.status + "\n" +
                "message : " + XMLHttpRequest.responseText + "\n" +
                "text status : " + textStatus + "\n" +
                "error : " + errorThrown);
        }
    });
};

function complete_merge_extcart(resp_json) {
    _console_log("[merge_extcart::RESPONSE]");
    //_console_log(resp_json);

    if (resp_json.result_code == "S0000")
    {
        //$.removeCookie("cart");

        if (window.location.pathname === "/cart")
        {
            if(window.CUSCart === undefined){
                show_extcart(resp_json.extcart_info);
            }

            else{
                window.CUSCart.show_extcart(resp_json.extcart_info);
            }

        }

        if (window.location.pathname != "/checkout")
        {
            truncate_cart_ajax(callback_of_truncate_cart, null);
        }

        if (window.location.pathname != "/cart" && window.location.pathname != "/checkout")
        {
            show_header_cart_count(resp_json.extcart_info);
        }

    }
    else
    {
        _console_log("merge_extcart failed.");
    }
}

var get_extcart_ajax = function (callback) {


    $.ajax
    ({
        type    : "GET",
        url     : _extapi_url + "?action=get_extcart&cart_token=" + _cart_token + "&customer_id=" + _customer_id,
        cache   : false,
        dataType: "json",
        async   : true,
        success : function (jsonData) {
            //_console_log("[cart.js::RESPONSE]");
            //_console_log(jsonData);
            callback(jsonData.extcart_info);
        },
        error   : function (XMLHttpRequest, textStatus, errorThrown) {
            show_ajax_response_error("1001", XMLHttpRequest, textStatus, errorThrown);
        }
    });
};





var truncate_cart_ajax = function (callback, params) {
    var url = "/cart/clear.js";

    if (params != null && params[1] == _k2k_subcart_id)
    {
        url = _k2k_home_url + url;
    }
    //_console_log("truncate_cart_ajax() url:"+url);

    $.ajax
    ({
        type    : "POST",
        url     : url,
        cache   : false,
        dataType: "json",
        async   : true,
        success : function (jsonData) {
            //_console_log("[cart.js::RESPONSE]");
            //_console_log(jsonData);
            callback(jsonData, params);
        },
        error   : function (XMLHttpRequest, textStatus, errorThrown) {
            show_ajax_response_error("1003", XMLHttpRequest, textStatus, errorThrown);
        }
    });
};

function callback_of_truncate_cart(resp_json, params) {
    _console_log("[Resp of truncate cart] :");
    //_console_log(resp_json);
}

function callback_of_truncate_cart_for_init_token(resp_json, params) {
    _console_log("[Resp of truncate cart] :");
    //_console_log(resp_json);

    _cart_token = getCookie("cart");
    //_console_log("_cart_token : |" + _cart_token + "|");
//alert("cart_token:|" + _cart_token + "|");
//___add_to_debug_log("[callback_of_truncate_cart_for_init_token()] _cart_token:|" + _cart_token + "|");
//___add_to_debug_log("[cookie] |" + document.cookie + "|");
//_console_log("___debug_log : |" + ___debug_log + "|");
//___send_debug_log_ajax(null, null);

    if (_cart_token == null || _cart_token == "")
    {
        _console_log("[ERROR] cart cookie empty again.");
        _cart_token = null;

        return false;
    }
}

function add_product_to_extcart(callback, variant_id, quantity, attributes) {
    add_product_to_extcart_ajax(callback, null, variant_id, quantity, attributes);
}

function add_to_extcart_in_product_page() {
    if (_is_adding_to_cart) return;



    var product_id = "";
    var variant_id = $("#productSelect").length > 0 ? $("#productSelect option:selected").val() : $("#option-radios input:checked").val();
    var quantity = $("#Quantity").val();
    var attributes = null;
    var $gift_card_wrap = $(".cl_product_single .gift-card-wrap");

    if($gift_card_wrap.length > 0 && $gift_card_wrap.is(":visible")){
        var gift_card_email = $gift_card_wrap.find("#gift-card-email").val();
        if(is_empty(gift_card_email)){
            window.cc_modal_dialog.alert("기프트카드를 받으실 이메일을 입력해주세요.");
            return;
        }else{
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if(!regex.test(gift_card_email)){
                window.cc_modal_dialog.alert("올바른 이메일형식으로 입력해주세요.");
                return;
            }
            attributes = Object();
            attributes.gift_card_email = gift_card_email;
            attributes.gift_card_recipient = $gift_card_wrap.find("#gift-card-recipient").val();
            attributes.gift_card_message = $gift_card_wrap.find("#gift-card-message").val();
        }
    }

    _is_adding_to_cart = true;
    add_product_to_extcart(proceed_after_adding_product_to_extcart, variant_id, quantity, attributes);
}

function on_click_add_to_cart_in_collection_page(btn_elm) {
    var variant_id = $(btn_elm).attr("variant_id");
    var quantity = 1;
    add_product_to_extcart(proceed_after_adding_product_to_extcart, variant_id, quantity, null);
}


function proceed_after_adding_product_to_extcart(resp_json) {
    _console_log("[RESPONSE] proceed_after_adding_product_to_extcart");
   // _console_log(resp_json);

    if(resp_json.result_code !== "S0000")
    {
        show_snackbar("장바구니에 담을 수 없습니다.");
        return;
    }

    var extcart_info = resp_json.extcart_info;
    var quantity_info = resp_json.quantity_info;

    //set_extcart_info(resp_json.extcart_info);
    show_header_cart_count(resp_json.extcart_info);


    var snack_msg = "장바구니에 상품을 담았습니다.";
    var snack_link = "장바구니 보기 〉";
    var snack_url = "/cart{subcart_param}#appview:장바구니";
    var subcart_param = "";

    //if(!is_empty(resp_json.quantity_info) && resp_json.quantity_info.is_over_max_quantity)
    if (!is_empty(quantity_info) && quantity_info.max_cart_quantity > 0 && quantity_info.new_cart_quantity >= quantity_info.max_cart_quantity)
    {
        snack_msg = "최대 구매수량이 " + quantity_info.max_cart_quantity + "개로 제한된 상품입니다.";
        snack_msg += "<br>현재 장바구니 수량 : " + quantity_info.new_cart_quantity + "개";
    }
    else
    {

        //장바구니 합계 금액 추가표시
        var cur_subcart_info = null;
        for (i = 0; i < extcart_info.subcart_list.length; i++)
        {
            if (extcart_info.subcart_list[i].subcart_id == quantity_info.subcart_id)
            {
                cur_subcart_info = extcart_info.subcart_list[i];
                break;
            }
        }
        var subcart_total_price = get_subcart_total_price(cur_subcart_info);
        if (cur_subcart_info != null && subcart_total_price > 0)
        {
            if (cur_subcart_info.subcart_title != "일반상품")
            {
                snack_msg = cur_subcart_info.subcart_title + " " + snack_msg;
            }

            snack_msg = snack_msg + "<br>총금액 $" + subcart_total_price.toFixed(2);

        }

        //장바구니에 추가한 상품의 subcart_id 확인

        if(!is_empty(cur_subcart_info)){
            var subcart_nicname = "";
            switch (cur_subcart_info.subcart_id){
                case "SUBCART_04":
                    subcart_nicname = "free_split_order"; break;
                case "SUBCART_05":
                    subcart_nicname = "cconma_fresh"; break;
                case "SUBCART_K2K_01":
                    subcart_nicname =  "k2k"; break;
                case "SUBCART_07":
                    subcart_nicname = "preorder"; break;
                case "SUBCART_15":
                    subcart_nicname = "giftcard"; break;
                case "SUBCART_21":
                    subcart_nicname = "whsale"; break;
                case "SUBCART_22":
                    subcart_nicname = "free_split_whsale"; break;
            }
            if(!is_empty(subcart_nicname)){
                subcart_param = ("?subcart=" + subcart_nicname);
            }
        }

    }

    snack_url = snack_url.replace("{subcart_param}",subcart_param);
    show_snackbar_with_link(snack_msg, snack_link,  snack_url);


}



var add_product_to_extcart_ajax = function (callback, product_id, variant_id, quantity, attributes) {
    $.ajax
    ({
        type    : "POST",
        url     : _ext9api_url,
        data    :
            {
                action     : "add_to_extcart",
                cart_token : _cart_token,
                customer_id: _customer_id,
                product_id : product_id,
                variant_id : variant_id,
                quantity   : quantity,
                attributes : attributes
            },
        cache   : false,
        dataType: "json",
        async   : true,
        success : function (jsonData) {
            if (jsonData.result_code != null)
            {
                _console_log("[RESPONSE] (" + jsonData.result_code + ") " + jsonData.result_msg);
                _console_log(jsonData);
            }

            if (jsonData.result_code == "S0000")
            {
                callback(jsonData);
            }
        },
        error   : function (XMLHttpRequest, textStatus, errorThrown) {
            show_ajax_response_error("1004", XMLHttpRequest, textStatus, errorThrown);
        },
        complete: function () {
            _is_adding_to_cart = false;
        }
    });
}







function show_header_cart_count(extcart_info) {
    if (extcart_info == null)
        return;

    /* //장바구니 상품 갯수
    var count = 0;

    if (!is_empty(extcart_info.subcart_list))
    {
        for (var i = 0; i < extcart_info.subcart_list.length; i++)
        {
            var subcart_info = extcart_info.subcart_list[i];
            count += subcart_info.item_list.length;
        }
    }


    var count_str = (count <= 0) ? "" : count;
     */

    //장바구니 결제금액
    var total_pay_price = 0;
    var total_pay_price_str = "";

    if (!is_empty(extcart_info.subcart_list))
    {
        for(i = 0; i < extcart_info.subcart_list.length; i++)
        {
            total_pay_price += get_subcart_total_price(extcart_info.subcart_list[i]);
        }
    }
    console.log("total_pay_price:"+total_pay_price);
    //if (count > 0 && total_pay_price > 0)
    if (total_pay_price > 0)
    {
        total_pay_price_str = " $" + total_pay_price.toFixed(2);
    }
    else
    {
        total_pay_price_str = "장바구니";
    }

    if (window.is_tablet_width()) //Mobile
    {
        if (!is_empty(total_pay_price_str))
        {
            console.log("total_pay_price_str:"+total_pay_price_str);
            $("#bottom-btn-cart-price").html(total_pay_price_str);
        }
    }
    else	//PC
    {
        console.log("total_pay_price_str:"+total_pay_price_str);
        jQuery(".cl_site_header #id_cart_item_count").html(total_pay_price_str);
    }

}

function get_subcart_total_price(subcart_info) {
    if (subcart_info == null)
        return 0;

    var total_pay_price = 0;
    var status_sale_str = "PS_ON_SALE";

    for (var i = 0; i < subcart_info.item_list.length; i++)
    {
        var item_info = subcart_info.item_list[i];
        if (item_info.checked_yn === "Y" && item_info.product_status === status_sale_str)
        {
            total_pay_price += item_info.line_price;
        }
    }
    return total_pay_price;
}



/*
  function ___add_to_debug_log(msg)
  {
    ___debug_log += msg + "\n";
  }

  var ___send_debug_log_ajax = function(callback, params)
  {
    $.ajax
    ({
      type		: "POST",
      url		: "//www.cconmausa.com/apps/extapi/jsapi",
      data		:
      {
        action: "___send_debug_log",
        cart_token: _cart_token,
        customer_id: _customer_id,
        ___debug_log: ___debug_log
      },
      cache		: false,
      dataType	: "json",
      async		: false,
      success		: function(jsonData)
      {
        //_console_log("[cart.js::RESPONSE]");
        //_console_log(jsonData);
        //callback(jsonData, params);
      },
      error		: function(XMLHttpRequest, textStatus, errorThrown)
      {
        
      }
    });
  };
*/